import useSWR from "swr";
import { useCreateProductServiceAdminAxiosInstance } from "../../Auth/useCreateProductServiceAdminAxiosInstance.ts";
import { BonificoOrderStatus } from "./BonificoOrderDTO.ts";

export function useBonificoOrderStatusCounts() {
  const { createAxiosInstance } = useCreateProductServiceAdminAxiosInstance();
  const { data, mutate } = useSWR(
    "/bonifico-orders/statistics/status-counts",
    async (url) => {
      const { data } = await createAxiosInstance().get<{
        counts: Partial<Record<BonificoOrderStatus, number>>;
      }>(url);
      return data;
    },
  );
  return {
    countOf: (status: BonificoOrderStatus) => data?.counts[status] ?? 0,
    refetch: mutate,
  };
}
